import { BaseGenerator } from '../core/BaseGenerator.js';

/**
 * Italian Fiscal Code generator following Single Responsibility Principle
 */
export class ItGenerator extends BaseGenerator {
  generate(options = {}) {
    const { lastName = null, firstName = null, birthDate = null, gender = null, birthPlace = null } = options;

    // Generate surname code (3 letters)
    const surnameCode = lastName ? this.extractConsonants(lastName, 3) : this.randomLetter() + this.randomLetter() + this.randomLetter();

    // Generate name code (3 letters)
    const nameCode = firstName ? this.extractConsonants(firstName, 3) : this.randomLetter() + this.randomLetter() + this.randomLetter();

    // Generate birth year (2 digits)
    let yearCode;
    if (birthDate) {
      yearCode = new Date(birthDate).getFullYear().toString().slice(-2);
    } else {
      yearCode = this.padZero(this.randomInt(0, 99), 2);
    }

    // Generate birth month (1 letter)
    const monthLetters = 'ABCDEHLMPRST';
    let monthCode;
    if (birthDate) {
      const month = new Date(birthDate).getMonth();
      monthCode = monthLetters[month];
    } else {
      monthCode = monthLetters[this.randomInt(0, monthLetters.length - 1)];
    }

    // Generate birth day and gender (2 digits)
    let dayCode;
    if (birthDate) {
      let day = new Date(birthDate).getDate();
      if (gender === 'female') day += 40;
      dayCode = this.padZero(day, 2);
    } else {
      let day = this.randomInt(1, 31);
      if (gender === 'female' || (gender === null && this.randomInt(0, 1))) {
        day += 40;
      }
      dayCode = this.padZero(day, 2);
    }

    // Generate birth place code (4 characters)
    const placeCode = birthPlace || ('H' + this.padZero(this.randomInt(1, 999), 3));

    // Calculate check digit
    const partial = surnameCode + nameCode + yearCode + monthCode + dayCode + placeCode;
    const checkDigit = this.calculateCheckDigit(partial);

    return partial + checkDigit;
  }

  extractConsonants(name, length) {
    const consonants = name.toUpperCase().replace(/[AEIOU\s]/g, '');
    const vowels = name.toUpperCase().replace(/[^AEIOU]/g, '');
    
    let result = consonants.substring(0, length);
    if (result.length < length) {
      result += vowels.substring(0, length - result.length);
    }
    
    while (result.length < length) {
      result += 'X';
    }
    
    return result.substring(0, length);
  }

  calculateCheckDigit(partial) {
    const oddValues = {
      '0': 1, '1': 0, '2': 5, '3': 7, '4': 9, '5': 13, '6': 15, '7': 17, '8': 19, '9': 21,
      'A': 1, 'B': 0, 'C': 5, 'D': 7, 'E': 9, 'F': 13, 'G': 15, 'H': 17, 'I': 19, 'J': 21,
      'K': 2, 'L': 4, 'M': 18, 'N': 20, 'O': 11, 'P': 3, 'Q': 6, 'R': 8, 'S': 12, 'T': 14,
      'U': 16, 'V': 10, 'W': 22, 'X': 25, 'Y': 24, 'Z': 23
    };
    
    const evenValues = {
      '0': 0, '1': 1, '2': 2, '3': 3, '4': 4, '5': 5, '6': 6, '7': 7, '8': 8, '9': 9,
      'A': 0, 'B': 1, 'C': 2, 'D': 3, 'E': 4, 'F': 5, 'G': 6, 'H': 7, 'I': 8, 'J': 9,
      'K': 10, 'L': 11, 'M': 12, 'N': 13, 'O': 14, 'P': 15, 'Q': 16, 'R': 17, 'S': 18, 'T': 19,
      'U': 20, 'V': 21, 'W': 22, 'X': 23, 'Y': 24, 'Z': 25
    };
    
    const checkLetters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    
    let sum = 0;
    for (let i = 0; i < 15; i++) {
      const char = partial[i];
      if (i % 2 === 0) {
        sum += oddValues[char];
      } else {
        sum += evenValues[char];
      }
    }
    
    return checkLetters[sum % 26];
  }
}